import { Injectable } from '@angular/core';
import { IReview, Review } from '@curbnturf/entities';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as ReviewsActions from './reviews.actions';
import { ReviewState } from './reviews.reducer';
import * as ReviewsSelectors from './reviews.selectors';

@Injectable({
  providedIn: 'root',
})
export class ReviewsFacade {
  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  allReviews$: Observable<ReviewState>;
  currentGuestReview$: Observable<IReview | undefined>;

  constructor(private store: Store) {
    this.allReviews$ = this.store.pipe(select(ReviewsSelectors.getAllReviews));
    this.currentGuestReview$ = this.store.pipe(select(ReviewsSelectors.getCurrentGuestReview));
  }

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */
  init() {
    this.store.dispatch(ReviewsActions.init());
  }

  loadListingReviews(listingId: number) {
    this.store.dispatch(ReviewsActions.loadListingReviews({ listingId }));
  }

  createBoondockReview(review: Review, boondockSiteId: number) {
    this.store.dispatch(ReviewsActions.createBoondockReview({ boondockSiteId, review }));
  }

  createGuestReview(review: Review, guestId: number) {
    this.store.dispatch(ReviewsActions.createGuestReview({ guestId, review }));
  }

  storeGuestReview(review: Review) {
    this.store.dispatch(ReviewsActions.storeGuestReview({ review }));
  }

  createPoiReview(review: Review, poiId: number) {
    this.store.dispatch(ReviewsActions.createPoiReview({ poiId, review }));
  }

  createListingReview(review: Review, listingId: number) {
    this.store.dispatch(ReviewsActions.createListingReview({ listingId, review }));
  }
}
